<main>
  <router-outlet></router-outlet>
  <app-toast
    [isVisible]="toastConfig.isVisible"
    [message]="toastConfig.message"
    [bgColor]="toastConfig.bgColor"
    [borderColor]="toastConfig.borderColor"
    [iconSrc]="toastConfig.iconSrc"
  ></app-toast>
</main>
